import { useNavigate } from "react-router-dom";
import { Scissors, Trash2, Film, FileAudio } from "lucide-react";
import { fmtBytes, fmtDuration, fmtRate, fmtChannels, fmtDate } from "@/lib/format";

export const MediaTable = ({ items, selected, onToggle, onSeparate, onDelete }) => {
  const nav = useNavigate();
  if (!items.length) {
    return <div data-testid="media-empty-state" className="panel p-10 text-center text-slate-500 text-sm">No masters ingested yet. Upload a master or generate a demo master to start.</div>;
  }
  return (
    <div className="panel overflow-x-auto">
      <table data-testid="media-table" className="w-full text-sm">
        <thead>
          <tr className="text-left micro border-b border-[#253044]">
            <th className="px-3 py-2.5 w-8"></th>
            <th className="px-3 py-2.5">Source file</th>
            <th className="px-3 py-2.5">Project / Ep</th>
            <th className="px-3 py-2.5">Duration</th>
            <th className="px-3 py-2.5">Sample rate</th>
            <th className="px-3 py-2.5">Bit depth</th>
            <th className="px-3 py-2.5">Channels</th>
            <th className="px-3 py-2.5">Codec</th>
            <th className="px-3 py-2.5">Size</th>
            <th className="px-3 py-2.5">Jobs</th>
            <th className="px-3 py-2.5">Ingested</th>
            <th className="px-3 py-2.5 text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map((m) => (
            <tr key={m.id} data-testid={`media-row-${m.id}`} className="row-hover border-b border-[#1c2433] last:border-0">
              <td className="px-3 py-2.5">
                <input type="checkbox" data-testid={`media-select-${m.id}`} checked={selected.includes(m.id)} onChange={() => onToggle(m.id)} className="accent-cyan-500" />
              </td>
              <td className="px-3 py-2.5">
                <div className="flex items-center gap-2 font-medium text-slate-100">
                  {m.source_has_video ? <Film size={14} className="text-slate-500" /> : <FileAudio size={14} className="text-slate-500" />}
                  <span className="truncate max-w-[260px]" title={m.source_filename}>{m.source_filename}</span>
                </div>
                {m.transcoded && <div className="text-[11px] text-amber-400/90 mt-0.5">{m.normalization_notes?.[0]}</div>}
              </td>
              <td className="px-3 py-2.5 font-mono text-xs text-slate-300">{m.project_id || "—"} / {m.episode_id || "—"}</td>
              <td className="px-3 py-2.5 font-mono text-xs">{fmtDuration(m.source_duration)}</td>
              <td className="px-3 py-2.5 font-mono text-xs">{fmtRate(m.source_sample_rate)}</td>
              <td className="px-3 py-2.5 font-mono text-xs">{m.source_bit_depth ? `${m.source_bit_depth}-bit` : "—"}</td>
              <td className="px-3 py-2.5 font-mono text-xs">{fmtChannels(m.source_channels, m.source_channel_layout)}</td>
              <td className="px-3 py-2.5 font-mono text-xs uppercase">{m.source_codec}</td>
              <td className="px-3 py-2.5 font-mono text-xs">{fmtBytes(m.source_file_size)}</td>
              <td className="px-3 py-2.5 font-mono text-xs">{m.job_count}</td>
              <td className="px-3 py-2.5 text-xs text-slate-400">{fmtDate(m.created_at)}</td>
              <td className="px-3 py-2.5">
                <div className="flex justify-end gap-1">
                  <button data-testid={`media-separate-${m.id}`} onClick={() => onSeparate(m)} title="Send to separation"
                    className="flex items-center gap-1.5 px-2.5 py-1 rounded-sm bg-[#E11D48] hover:bg-[#be123c] text-white text-xs font-medium transition-colors">
                    <Scissors size={12} /> Separate
                  </button>
                  <button data-testid={`media-jobs-${m.id}`} onClick={() => nav(`/jobs?media=${m.id}`)} className="px-2.5 py-1 rounded-sm border border-[#253044] hover:bg-[#1E2738] text-xs">Jobs</button>
                  <button data-testid={`media-delete-${m.id}`} onClick={() => onDelete(m)} className="p-1.5 rounded-sm border border-[#253044] hover:bg-rose-500/10 hover:text-rose-400 text-slate-400"><Trash2 size={13} /></button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
